module.exports = __webpack_public_path__ + "media/images/athletes/3517-1c2e4bd95657461ac6b579b90c6f5b0d.png";